import { createFileRoute } from '@tanstack/react-router';
import { i18next } from '@frontend/i18n';
import { PrivacyPolicyPage } from '../pages';

export const Route = createFileRoute('/legal/privacy-policy_/$locationId')({
  component: PrivacyPolicyPage,
  head: () => ({
    meta: [
      {
        title: i18next.t('Privacy Policy', { ns: 'digital-forms-experience' }),
      },
    ],
  }),
});
